module.exports = __webpack_public_path__ + "img/mng-logo-mob.c4b94edb.png";